import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import {
  LoginContainer,
  Title,
  FormStyled,
  ErrorText,
  AdminLoginCard,
  Header,
  Logo,
} from './style'
import Input from '@components/fields/input'

import { toast } from 'react-toastify'
import Button from '@components/button'
import Column from '@components/column'
import Topbar from '@commons/layouts/private/admin/components/Topbar'
import { Admin } from '@apis/index'
import { Helper } from '@utils/index'
import Fields from '@components/fields'

const AdminLogin = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const initialState = {
    username: '',
    password: '',
  }
  const { pathname } = useLocation()

  const isAdminLogin = pathname.includes('admin-login') ? true : false

  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      const payload: { username: string; password: string } = {
        username: values.username,
        password: values.password,
      }
      if (!!isAdminLogin) {
        const res = await Admin.login({ data: payload })
        console.log({ res })
        await Helper.saveUser({ ...res, infos: res.infos })
        navigate(`/${res?.role}`)
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <LoginContainer>
        <AdminLoginCard>
          <Title>Admin Login</Title>
          <Formik initialValues={initialState} onSubmit={handleSubmit}>
            <Form>
              <Column>
                <Fields.Input
                  name="username"
                  label="Username"
                  placeholder="Username"
                />
                <Fields.Password
                  name="password"
                  label="Password"
                  placeholder="Password"
                />
                <Button
                  justify="center"
                  width={100}
                  height={45}
                  title={loading ? 'Logging in...' : 'Login'}
                  type="submit"
                />
              </Column>
            </Form>
          </Formik>
        </AdminLoginCard>
      </LoginContainer>
    </>
  )
}

export default AdminLogin
